/* from https://github.com/final-form/final-form-set-field-touched
 * tsc didn't like the yarn version
 */

const setFieldTouched = (args, state) => {
  const [name, touched] = args;
  const field = state.fields[name];
  if (field) {
    field.touched = !!touched;
  }
};

export default setFieldTouched;
